export const hasMainEntities = (tree) =>
  !!(tree.data && tree.data.entities && tree.data.entities.length);

export const getNameFromEntityType = (node) =>
  node.data.entities && node.data.entities[0] && node.data.entities[0].type;

export const markMainEntity = (tree) => {
  const menuMainObject = tree.data.messages.find(
    (msg) =>
      msg.name === getNameFromEntityType(tree).toLowerCase() ||
      msg.name === getNameFromEntityType(tree)
  );
  menuMainObject && (menuMainObject.isMainObject = true);
  return menuMainObject;
};
export const reorderLinksAndPutMainObjectOnTop = (links, tree) => {
  const menuMainObject = markMainEntity(tree);
  return menuMainObject ? [menuMainObject, ...links] : links;
};
export const shouldAddWebhook = (tree) =>
  !!(tree.data && tree.data.events && tree.data.events.length);
